export default __webpack_public_path__ + "static/Hack-Bold-7f6f940fe3d611459abbb751dbe4c25a.woff2";